import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import { CustomerDto } from '../models/customer.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CustomerService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/customers`;

  searchCustomers(search: string): Observable<ApiResponse<CustomerDto[]>> {
    const params = new HttpParams().set('search', search);
    return this.http.get<ApiResponse<CustomerDto[]>>(this.endpoint, { params });
  }
}
